import { DividendRecord } from '../types/hiro';
import dayjs from 'dayjs';
import { ET } from './shared/date';

// Convert dividend records into dividend dates and dividend amounts.
// Dividend dates are expressed as fractional years from now.
// Past dividends (date < 0.0) are filtered out.
export function transformDividendsToRiskEngineFormat(
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  dividends: DividendRecord[] | unknown,
  currentDate: number = dayjs().tz(ET).valueOf(),
): {
  dividendDates: Float64Array;
  dividendAmounts: Float64Array;
} {
  if (!Array.isArray(dividends) || dividends.length === 0) {
    return {
      dividendDates: new Float64Array(0),
      dividendAmounts: new Float64Array(0),
    };
  }

  const millisecondsPerYear = 365.25 * 24 * 60 * 60 * 1_000;

  const validDividends = (dividends as DividendRecord[]).filter((d) => {
    if (d == null || typeof d !== 'object') {
      return false;
    }
    const hasDate = d.date != null && d.date !== '';
    const hasAmount =
      (d.dividend !== null && d.dividend !== undefined) || d.adj_dividend > 0;
    if (!hasDate || !hasAmount) {
      return false;
    }

    const dividendDate = new Date(d.date).getTime();
    const yearsToDividend = (dividendDate - currentDate) / millisecondsPerYear;
    return yearsToDividend >= 0.0;
  });

  if (validDividends.length === 0) {
    return {
      dividendDates: new Float64Array(0),
      dividendAmounts: new Float64Array(0),
    };
  }

  const sortedDividends = [...validDividends].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );

  const dividendDates = new Float64Array(sortedDividends.length);
  const dividendAmounts = new Float64Array(sortedDividends.length);

  sortedDividends.forEach((dividend, index) => {
    const dividendDate = new Date(dividend.date).getTime();
    const yearsToDividend = (dividendDate - currentDate) / millisecondsPerYear;

    dividendDates[index] = yearsToDividend;
    dividendAmounts[index] = dividend.adj_dividend ?? dividend.dividend ?? 0;
  });

  return {
    dividendDates,
    dividendAmounts,
  };
}
